export function formatMoney(price, currency = "AED") {
  const amount = Number(price || 0);
  return `${currency} ${amount.toLocaleString(undefined, {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
}

export function periodLabel(pkg = {}) {
  const cycle = String(pkg.billing_cycle || "").toLowerCase();
  const unit = String(pkg.duration_unit || "").toLowerCase();
  if (cycle === "annual" || unit === "year") return "/ year";
  return "/ month";
}

export function typeLabel(type) {
  const value = String(type || "");
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}

export function cycleLabel(cycle) {
  const value = String(cycle || "");
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}

export function featureTexts(item = {}) {
  return (item.features || [])
    .map((feature) => (typeof feature === "string" ? feature : feature?.feature_text || ""))
    .filter(Boolean);
}

export function startingPrice(packages = []) {
  const priced = packages.filter(
    (pkg) => pkg.cta_type !== "contact" && Number(pkg.is_active) === 1 && Number(pkg.price) > 0
  );
  if (!priced.length) return null;
  return priced.reduce((min, pkg) => (Number(pkg.price) < Number(min.price) ? pkg : min), priced[0]);
}
